module.exports = __webpack_public_path__ + "img/102.71037950.jpg";